import {mergeAll} from 'ramda';

import {DmsDataGrid} from '@dms/shared';

import {RequiredTestIdProps} from 'shared/web';

import type {QueryFilterObject} from 'features/eag-grid';

const SERVICE_ACCOUNT_REQUEST_LOG_GRID_CODE = 'service-account-request-log';

interface ServiceAccountRequestLogTabProps extends RequiredTestIdProps {
  serviceAccountId: string;
}

export function ServiceAccountRequestLogTab(props: ServiceAccountRequestLogTabProps) {
  // The backend grid carries a permanently-hidden `serviceAccountId` column and
  // rejects the query unless that filter is provided, so we inject the current
  // SA id into every request via the queryModifier.
  const queryModifier = (filter: QueryFilterObject) =>
    mergeAll([filter, {serviceAccountId: props.serviceAccountId}]);

  return (
    <DmsDataGrid
      gridCode={SERVICE_ACCOUNT_REQUEST_LOG_GRID_CODE}
      autoHeight
      queryModifier={queryModifier}
      data-testid={props['data-testid']}
    />
  );
}
